var router = require('pjax').Router;
var domain = require('./domain.js');
var integration = require('./integration.js');
var registration = require('./registration.js');
var social = require('./social.js');

router.get('setting/domain', domain);
router.get('setting/integration', integration);
router.get('setting/api-v1', integration);
router.get('setting/registration', registration);
router.get('setting/social', social);
